import BaseModel from './base';
import UserPortfolio from './user-portfolio';

export const DEFAULT_DOCUMENT_FILE_COUNT = 1;
export const MAX_DOCUMENT_FILE_COUNT = 5;
/**
  так. смотри как грузить файлы где нету directory_id

  POST 1/event-directory-document/1386/upload
  вот сюда

  {
    "document": {
      "name": "YIqLbgptLByLIfu56ombT1bA2e4UCQ8o.xlsx",
      "original_name": "original_name"
      // --- ИЛИ ---
      "id": 245,
    },
    "user_id": 9
  }
  user_id - это когда от тренера грузишь
 */
export default class EventDocument extends BaseModel {
  static getDocCount(document = {}) {
    const count = Number(document.doc_count ?? document.settings?.doc_count ?? DEFAULT_DOCUMENT_FILE_COUNT);
    return Number.isInteger(count) && count > 0 ? Math.min(count, MAX_DOCUMENT_FILE_COUNT) : DEFAULT_DOCUMENT_FILE_COUNT;
  }

  static fileKey(value) {
    const file = EventDocument.serializeFile(value);
    if (file?.id) return `id:${file.id}`;
    return file?.name ? `name:${file.name}` : null;
  }

  static normalizeFiles(value) {
    const files = (Array.isArray(value) ? value : [value]).filter(Boolean).map((file) => file.document || file);
    return [...new Map(files.filter((file) => EventDocument.fileKey(file))
      .map((file) => [EventDocument.fileKey(file), file])).values()];
  }

  static filesFrom(document = {}) {
    const value = document.user_values ?? document.response?.user_values
      ?? document.user_value ?? document.response?.user_value;
    return EventDocument.normalizeFiles(value);
  }

  static serializeFiles(value) {
    return EventDocument.normalizeFiles(value).map((file) => EventDocument.serializeFile(file))
      .sort((left, right) => EventDocument.fileKey(left).localeCompare(EventDocument.fileKey(right)));
  }

  static serializeFile(value) {
    const file = value?.document || value;
    if (file?.id) return { id: file.id };
    const name = file?.file_name || file?.name;
    return name ? { name, original_name: file.original_name } : undefined;
  }

  constructor(document, url) {
    super(document, url);

    this.assign = document.assign || []; // [{ event_id: 1377, nomination_id: 1958 }, ...]
    this.settings = document.settings || {};
    this.doc_count = EventDocument.getDocCount(document);

    this.title = document.title || ''; // Используется, когда directory_id === null

    this.directory_id = document.directory_id || null;
    this.directory_name = document.directory_name || '';

    this.required = document.required;
    this.description = document.description;

    this.event_id = document.event_id;
    this.nomination_id = document.nomination_id;

    this.agreement = document.agreement || null; // { id, text }
    this.template = document.template || null; // { id, url }

    this.global_document_type_id = document.global_document_type_id || null;

    this.setValues(EventDocument.filesFrom(document));
  }

  get displayTitle() {
    return this.directory_name || this.title || this.description || 'Документ';
  }

  totalAssign(eventId, nominationId) {
    return (!this.event_id || this.event_id === eventId)
      && (this.nomination_id === nominationId || !this.nomination_id);
  }

  currentAssign(eventId, nominationId) {
    return (this.assign || []).find(({ event_id, nomination_id }) =>
      eventId === event_id && nomination_id === (nominationId || null),
    );
  }

  isAssigned(eventId, nominationId) {
    return !!this.currentAssign(eventId, nominationId);
  }

  isGlobal(eventId) {
    return !!this.currentAssign(eventId, null);
  }

  get isSystem() {
    return !!this.settings?.global;
  }

  assignRequired(eventId, nominationId) {
    const globalRequired = this.currentAssign(eventId, null);
    return this.currentAssign(eventId, nominationId)?.options?.required
      ?? globalRequired?.options?.required
      ?? this.required;
  }

  setValue(val) {
    this.setValues(val);
  }

  setValues(value) {
    this.user_values = EventDocument.normalizeFiles(value);
    const [first] = this.user_values;
    // Keep the first-file adapter for remaining legacy portfolio consumers.
    this.user_value = this.global_document_type_id && first ? new UserPortfolio(first) : first || null;
  }
}
